import Environment from "utils/Environment";

export default class Countries {
  static getFlagIconUrl(countryCode) {
    return `${Environment.getProcessEnvVars().SVG_FLAG_ICONS_URL}/${countryCode}.svg`;
  }
}
